export default __webpack_public_path__ + "static/media/support.db75fcb4.svg";